{
 "generatedAt": "2026-06-28T02:22:44.967Z",
 "source": "salimt/football-datasets (Transfermarkt)",
 "values": {
  "GER": 906000000,
  "ENG": 1402000000,
  "USA": 364000000,
  "ESP": 1438000000,
  "AUS": 44150000,
  "ARG": 857000000,
  "SCO": 261000000,
  "NED": 829000000,
  "BRA": 1397000000,
  "POR": 981000000,
  "FRA": 1420000000,
  "PAR": 107400000,
  "TUR": 309000000,
  "AUT": 165400000,
  "NOR": 546000000,
  "CAN": 164700000,
  "ALG": 158400000,
  "CIV": 472000000,
  "MEX": 191500000,
  "COL": 309000000,
  "KOR": 135800000,
  "MAR": 341000000,
  "ECU": 184100000,
  "SUI": 361000000,
  "BEL": 523000000,
  "CRO": 273500000,
  "BIH": 296500000,
  "NZL": 25750000,
  "SWE": 515500000,
  "TUN": 51700000,
  "CZE": 135000000,
  "HTI": 14275000,
  "URU": 474000000,
  "GHA": 364000000,
  "QAT": 17775000,
  "CUW": 8725000,
  "JPN": 305500000,
  "SEN": 229000000,
  "CPV": 29950000,
  "COD": 97300000,
  "IRN": 25750000,
  "RSA": 16400000,
  "UZB": 42350000,
  "IRQ": 10200000,
  "EGY": 142350000,
  "PAN": 14175000,
  "JOR": 6350000,
  "KSA": 425000
 },
 "playersLite": {
  "GER": [
   {
    "id": 580195,
    "value": 140000000
   },
   {
    "id": 309400,
    "value": 65000000
   },
   {
    "id": 792380,
    "value": 55000000
   },
   {
    "id": 161056,
    "value": 45000000
   },
   {
    "id": 443710,
    "value": 45000000
   },
   {
    "id": 496094,
    "value": 45000000
   },
   {
    "id": 730861,
    "value": 45000000
   },
   {
    "id": 388198,
    "value": 40000000
   },
   {
    "id": 324503,
    "value": 35000000
   },
   {
    "id": 333647,
    "value": 35000000
   },
   {
    "id": 441986,
    "value": 35000000
   },
   {
    "id": 192565,
    "value": 32000000
   },
   {
    "id": 196357,
    "value": 30000000
   },
   {
    "id": 455661,
    "value": 30000000
   },
   {
    "id": 822959,
    "value": 30000000
   },
   {
    "id": 406640,
    "value": 28000000
   },
   {
    "id": 425918,
    "value": 28000000
   },
   {
    "id": 187492,
    "value": 25000000
   },
   {
    "id": 425334,
    "value": 25000000
   },
   {
    "id": 578392,
    "value": 25000000
   },
   {
    "id": 503160,
    "value": 24000000
   },
   {
    "id": 153084,
    "value": 22000000
   },
   {
    "id": 159471,
    "value": 22000000
   }
  ],
  "ENG": [
   {
    "id": 433177,
    "value": 150000000
   },
   {
    "id": 357662,
    "value": 120000000
   },
   {
    "id": 406635,
    "value": 100000000
   },
   {
    "id": 132098,
    "value": 75000000
   },
   {
    "id": 314353,
    "value": 75000000
   },
   {
    "id": 503733,
    "value": 65000000
   },
   {
    "id": 406040,
    "value": 60000000
   },
   {
    "id": 479999,
    "value": 55000000
   },
   {
    "id": 614258,
    "value": 55000000
   },
   {
    "id": 890719,
    "value": 55000000
   },
   {
    "id": 258923,
    "value": 50000000
   },
   {
    "id": 429014,
    "value": 50000000
   },
   {
    "id": 461496,
    "value": 50000000
   },
   {
    "id": 661053,
    "value": 50000000
   },
   {
    "id": 820374,
    "value": 50000000
   },
   {
    "id": 335721,
    "value": 45000000
   },
   {
    "id": 392757,
    "value": 45000000
   },
   {
    "id": 433188,
    "value": 45000000
   },
   {
    "id": 890721,
    "value": 45000000
   },
   {
    "id": 294057,
    "value": 42000000
   },
   {
    "id": 258889,
    "value": 40000000
   },
   {
    "id": 314875,
    "value": 40000000
   },
   {
    "id": 470607,
    "value": 40000000
   }
  ],
  "USA": [
   {
    "id": 315779,
    "value": 50000000
   },
   {
    "id": 349701,
    "value": 35000000
   },
   {
    "id": 689505,
    "value": 25000000
   },
   {
    "id": 807386,
    "value": 24000000
   },
   {
    "id": 332697,
    "value": 22000000
   },
   {
    "id": 503991,
    "value": 20000000
   },
   {
    "id": 332705,
    "value": 18000000
   },
   {
    "id": 503770,
    "value": 18000000
   },
   {
    "id": 361104,
    "value": 16000000
   },
   {
    "id": 627207,
    "value": 16000000
   },
   {
    "id": 393323,
    "value": 15000000
   },
   {
    "id": 341049,
    "value": 14000000
   },
   {
    "id": 578539,
    "value": 14000000
   },
   {
    "id": 504153,
    "value": 10000000
   },
   {
    "id": 542877,
    "value": 10000000
   },
   {
    "id": 315291,
    "value": 8000000
   },
   {
    "id": 746833,
    "value": 8000000
   },
   {
    "id": 795738,
    "value": 8000000
   },
   {
    "id": 711517,
    "value": 7500000
   },
   {
    "id": 389255,
    "value": 7000000
   },
   {
    "id": 686806,
    "value": 6500000
   },
   {
    "id": 389253,
    "value": 6000000
   },
   {
    "id": 429259,
    "value": 6000000
   }
  ],
  "ESP": [
   {
    "id": 937958,
    "value": 200000000
   },
   {
    "id": 683840,
    "value": 140000000
   },
   {
    "id": 357565,
    "value": 110000000
   },
   {
    "id": 962110,
    "value": 80000000
   },
   {
    "id": 709187,
    "value": 70000000
   },
   {
    "id": 293385,
    "value": 60000000
   },
   {
    "id": 423440,
    "value": 60000000
   },
   {
    "id": 571020,
    "value": 60000000
   },
   {
    "id": 636688,
    "value": 60000000
   },
   {
    "id": 646740,
    "value": 60000000
   },
   {
    "id": 775605,
    "value": 55000000
   },
   {
    "id": 636703,
    "value": 50000000
   },
   {
    "id": 991268,
    "value": 50000000
   },
   {
    "id": 262749,
    "value": 40000000
   },
   {
    "id": 350219,
    "value": 40000000
   },
   {
    "id": 351809,
    "value": 40000000
   },
   {
    "id": 398184,
    "value": 40000000
   },
   {
    "id": 466805,
    "value": 40000000
   },
   {
    "id": 524000,
    "value": 40000000
   },
   {
    "id": 553875,
    "value": 38000000
   },
   {
    "id": 284857,
    "value": 35000000
   },
   {
    "id": 338424,
    "value": 35000000
   },
   {
    "id": 811778,
    "value": 35000000
   }
  ],
  "AUS": [
   {
    "id": 298091,
    "value": 6000000
   },
   {
    "id": 956920,
    "value": 4000000
   },
   {
    "id": 867762,
    "value": 3500000
   },
   {
    "id": 385918,
    "value": 3000000
   },
   {
    "id": 409153,
    "value": 3000000
   },
   {
    "id": 428061,
    "value": 3000000
   },
   {
    "id": 128969,
    "value": 2500000
   },
   {
    "id": 192557,
    "value": 2000000
   },
   {
    "id": 255788,
    "value": 2000000
   },
   {
    "id": 957224,
    "value": 2000000
   },
   {
    "id": 591844,
    "value": 1500000
   },
   {
    "id": 1109824,
    "value": 1300000
   },
   {
    "id": 399990,
    "value": 1200000
   },
   {
    "id": 173591,
    "value": 1000000
   },
   {
    "id": 214798,
    "value": 1000000
   },
   {
    "id": 303420,
    "value": 1000000
   },
   {
    "id": 399162,
    "value": 1000000
   },
   {
    "id": 734487,
    "value": 1000000
   },
   {
    "id": 565531,
    "value": 900000
   },
   {
    "id": 603864,
    "value": 900000
   },
   {
    "id": 470618,
    "value": 800000
   },
   {
    "id": 680531,
    "value": 800000
   },
   {
    "id": 153882,
    "value": 750000
   }
  ],
  "ARG": [
   {
    "id": 576024,
    "value": 100000000
   },
   {
    "id": 406625,
    "value": 95000000
   },
   {
    "id": 648195,
    "value": 75000000
   },
   {
    "id": 355915,
    "value": 50000000
   },
   {
    "id": 401578,
    "value": 40000000
   },
   {
    "id": 480762,
    "value": 40000000
   },
   {
    "id": 742201,
    "value": 35000000
   },
   {
    "id": 849520,
    "value": 35000000
   },
   {
    "id": 948294,
    "value": 35000000
   },
   {
    "id": 756990,
    "value": 32000000
   },
   {
    "id": 467992,
    "value": 30000000
   },
   {
    "id": 668951,
    "value": 30000000
   },
   {
    "id": 368482,
    "value": 25000000
   },
   {
    "id": 459763,
    "value": 25000000
   },
   {
    "id": 474800,
    "value": 25000000
   },
   {
    "id": 522784,
    "value": 25000000
   },
   {
    "id": 746712,
    "value": 25000000
   },
   {
    "id": 930781,
    "value": 25000000
   },
   {
    "id": 486031,
    "value": 24000000
   },
   {
    "id": 469781,
    "value": 22000000
   },
   {
    "id": 572265,
    "value": 22000000
   },
   {
    "id": 627626,
    "value": 22000000
   },
   {
    "id": 111873,
    "value": 20000000
   }
  ],
  "SCO": [
   {
    "id": 315969,
    "value": 50000000
   },
   {
    "id": 428563,
    "value": 28000000
   },
   {
    "id": 423744,
    "value": 20000000
   },
   {
    "id": 234803,
    "value": 18000000
   },
   {
    "id": 193116,
    "value": 16000000
   },
   {
    "id": 346779,
    "value": 15000000
   },
   {
    "id": 424015,
    "value": 15000000
   },
   {
    "id": 719673,
    "value": 14000000
   },
   {
    "id": 188077,
    "value": 10000000
   },
   {
    "id": 591949,
    "value": 10000000
   },
   {
    "id": 300716,
    "value": 9000000
   },
   {
    "id": 924857,
    "value": 8000000
   },
   {
    "id": 801426,
    "value": 7500000
   },
   {
    "id": 193081,
    "value": 6000000
   },
   {
    "id": 362562,
    "value": 6000000
   },
   {
    "id": 567129,
    "value": 5000000
   },
   {
    "id": 235767,
    "value": 4000000
   },
   {
    "id": 255906,
    "value": 4000000
   },
   {
    "id": 430310,
    "value": 4000000
   },
   {
    "id": 429309,
    "value": 3500000
   },
   {
    "id": 341317,
    "value": 3000000
   },
   {
    "id": 225744,
    "value": 2500000
   },
   {
    "id": 298477,
    "value": 2500000
   }
  ],
  "NED": [
   {
    "id": 478573,
    "value": 75000000
   },
   {
    "id": 434675,
    "value": 70000000
   },
   {
    "id": 460939,
    "value": 60000000
   },
   {
    "id": 420243,
    "value": 55000000
   },
   {
    "id": 557459,
    "value": 50000000
   },
   {
    "id": 326330,
    "value": 45000000
   },
   {
    "id": 326031,
    "value": 38000000
   },
   {
    "id": 321528,
    "value": 35000000
   },
   {
    "id": 330659,
    "value": 35000000
   },
   {
    "id": 360518,
    "value": 35000000
   },
   {
    "id": 576314,
    "value": 32000000
   },
   {
    "id": 420213,
    "value": 30000000
   },
   {
    "id": 435648,
    "value": 30000000
   },
   {
    "id": 470394,
    "value": 28000000
   },
   {
    "id": 177476,
    "value": 25000000
   },
   {
    "id": 326029,
    "value": 25000000
   },
   {
    "id": 339332,
    "value": 25000000
   },
   {
    "id": 415381,
    "value": 25000000
   },
   {
    "id": 139208,
    "value": 23000000
   },
   {
    "id": 347900,
    "value": 22000000
   },
   {
    "id": 473169,
    "value": 22000000
   },
   {
    "id": 474701,
    "value": 22000000
   },
   {
    "id": 541231,
    "value": 22000000
   }
  ],
  "BRA": [
   {
    "id": 371998,
    "value": 170000000
   },
   {
    "id": 411295,
    "value": 90000000
   },
   {
    "id": 412363,
    "value": 90000000
   },
   {
    "id": 315853,
    "value": 80000000
   },
   {
    "id": 255942,
    "value": 75000000
   },
   {
    "id": 435338,
    "value": 75000000
   },
   {
    "id": 397033,
    "value": 60000000
   },
   {
    "id": 517894,
    "value": 60000000
   },
   {
    "id": 1005649,
    "value": 55000000
   },
   {
    "id": 655488,
    "value": 55000000
   },
   {
    "id": 198116,
    "value": 50000000
   },
   {
    "id": 364135,
    "value": 50000000
   },
   {
    "id": 386446,
    "value": 50000000
   },
   {
    "id": 516716,
    "value": 50000000
   },
   {
    "id": 607854,
    "value": 50000000
   },
   {
    "id": 626724,
    "value": 50000000
   },
   {
    "id": 743591,
    "value": 50000000
   },
   {
    "id": 554903,
    "value": 45000000
   },
   {
    "id": 659089,
    "value": 42000000
   },
   {
    "id": 315858,
    "value": 40000000
   },
   {
    "id": 735570,
    "value": 40000000
   },
   {
    "id": 333241,
    "value": 35000000
   },
   {
    "id": 394300,
    "value": 35000000
   }
  ],
  "POR": [
   {
    "id": 487469,
    "value": 80000000
   },
   {
    "id": 670681,
    "value": 80000000
   },
   {
    "id": 357164,
    "value": 70000000
   },
   {
    "id": 258004,
    "value": 65000000
   },
   {
    "id": 240306,
    "value": 50000000
   },
   {
    "id": 487465,
    "value": 50000000
   },
   {
    "id": 1138758,
    "value": 45000000
   },
   {
    "id": 549006,
    "value": 45000000
   },
   {
    "id": 340950,
    "value": 40000000
   },
   {
    "id": 357153,
    "value": 40000000
   },
   {
    "id": 550550,
    "value": 40000000
   },
   {
    "id": 957653,
    "value": 40000000
   },
   {
    "id": 241641,
    "value": 38000000
   },
   {
    "id": 412669,
    "value": 35000000
   },
   {
    "id": 601883,
    "value": 35000000
   },
   {
    "id": 504087,
    "value": 32000000
   },
   {
    "id": 257455,
    "value": 30000000
   },
   {
    "id": 357147,
    "value": 30000000
   },
   {
    "id": 426620,
    "value": 30000000
   },
   {
    "id": 487474,
    "value": 28000000
   },
   {
    "id": 606718,
    "value": 28000000
   },
   {
    "id": 225161,
    "value": 25000000
   },
   {
    "id": 535955,
    "value": 25000000
   }
  ],
  "FRA": [
   {
    "id": 342229,
    "value": 180000000
   },
   {
    "id": 566723,
    "value": 100000000
   },
   {
    "id": 288230,
    "value": 90000000
   },
   {
    "id": 495666,
    "value": 80000000
   },
   {
    "id": 318528,
    "value": 75000000
   },
   {
    "id": 413112,
    "value": 75000000
   },
   {
    "id": 709726,
    "value": 75000000
   },
   {
    "id": 411975,
    "value": 65000000
   },
   {
    "id": 357119,
    "value": 60000000
   },
   {
    "id": 640428,
    "value": 60000000
   },
   {
    "id": 413039,
    "value": 55000000
   },
   {
    "id": 923831,
    "value": 55000000
   },
   {
    "id": 344695,
    "value": 50000000
   },
   {
    "id": 270541,
    "value": 45000000
   },
   {
    "id": 607223,
    "value": 45000000
   },
   {
    "id": 745200,
    "value": 45000000
   },
   {
    "id": 394327,
    "value": 40000000
   },
   {
    "id": 463618,
    "value": 40000000
   },
   {
    "id": 624690,
    "value": 40000000
   },
   {
    "id": 973085,
    "value": 40000000
   },
   {
    "id": 344381,
    "value": 35000000
   },
   {
    "id": 564545,
    "value": 35000000
   },
   {
    "id": 569366,
    "value": 35000000
   }
  ],
  "PAR": [
   {
    "id": 660867,
    "value": 22000000
   },
   {
    "id": 745191,
    "value": 12000000
   },
   {
    "id": 353032,
    "value": 8000000
   },
   {
    "id": 675178,
    "value": 7500000
   },
   {
    "id": 215390,
    "value": 5000000
   },
   {
    "id": 355817,
    "value": 4500000
   },
   {
    "id": 1060740,
    "value": 4000000
   },
   {
    "id": 1283997,
    "value": 4000000
   },
   {
    "id": 323872,
    "value": 4000000
   },
   {
    "id": 542344,
    "value": 4000000
   },
   {
    "id": 417327,
    "value": 3500000
   },
   {
    "id": 514120,
    "value": 3500000
   },
   {
    "id": 273000,
    "value": 3000000
   },
   {
    "id": 353037,
    "value": 3000000
   },
   {
    "id": 491599,
    "value": 3000000
   },
   {
    "id": 234523,
    "value": 2800000
   },
   {
    "id": 661269,
    "value": 2500000
   },
   {
    "id": 285548,
    "value": 2000000
   },
   {
    "id": 401726,
    "value": 2000000
   },
   {
    "id": 661245,
    "value": 2000000
   },
   {
    "id": 401728,
    "value": 1800000
   },
   {
    "id": 527494,
    "value": 1800000
   },
   {
    "id": 353035,
    "value": 1500000
   }
  ],
  "TUR": [
   {
    "id": 845654,
    "value": 50000000
   },
   {
    "id": 126414,
    "value": 30000000
   },
   {
    "id": 454567,
    "value": 30000000
   },
   {
    "id": 369316,
    "value": 25000000
   },
   {
    "id": 503871,
    "value": 20000000
   },
   {
    "id": 396908,
    "value": 14000000
   },
   {
    "id": 340879,
    "value": 13000000
   },
   {
    "id": 232320,
    "value": 12000000
   },
   {
    "id": 345590,
    "value": 12000000
   },
   {
    "id": 926993,
    "value": 12000000
   },
   {
    "id": 251106,
    "value": 10000000
   },
   {
    "id": 292199,
    "value": 9500000
   },
   {
    "id": 336077,
    "value": 8000000
   },
   {
    "id": 1043003,
    "value": 7500000
   },
   {
    "id": 846310,
    "value": 7500000
   },
   {
    "id": 199316,
    "value": 7000000
   },
   {
    "id": 216603,
    "value": 7000000
   },
   {
    "id": 251075,
    "value": 6000000
   },
   {
    "id": 353922,
    "value": 6000000
   },
   {
    "id": 361256,
    "value": 6000000
   },
   {
    "id": 391005,
    "value": 6000000
   },
   {
    "id": 514895,
    "value": 5500000
   },
   {
    "id": 1042886,
    "value": 5000000
   }
  ],
  "AUT": [
   {
    "id": 223967,
    "value": 25000000
   },
   {
    "id": 263236,
    "value": 25000000
   },
   {
    "id": 225657,
    "value": 12000000
   },
   {
    "id": 324278,
    "value": 12000000
   },
   {
    "id": 223979,
    "value": 10000000
   },
   {
    "id": 268429,
    "value": 8500000
   },
   {
    "id": 106987,
    "value": 8000000
   },
   {
    "id": 223974,
    "value": 8000000
   },
   {
    "id": 263361,
    "value": 8000000
   },
   {
    "id": 59016,
    "value": 6000000
   },
   {
    "id": 186368,
    "value": 4500000
   },
   {
    "id": 287188,
    "value": 4000000
   },
   {
    "id": 346849,
    "value": 4000000
   },
   {
    "id": 369567,
    "value": 4000000
   },
   {
    "id": 451906,
    "value": 4000000
   },
   {
    "id": 106872,
    "value": 3500000
   },
   {
    "id": 120205,
    "value": 3000000
   },
   {
    "id": 41384,
    "value": 3000000
   },
   {
    "id": 526895,
    "value": 3000000
   },
   {
    "id": 322655,
    "value": 2700000
   },
   {
    "id": 438961,
    "value": 2500000
   },
   {
    "id": 59145,
    "value": 2500000
   },
   {
    "id": 548031,
    "value": 2200000
   }
  ],
  "NOR": [
   {
    "id": 418560,
    "value": 180000000
   },
   {
    "id": 316264,
    "value": 85000000
   },
   {
    "id": 429983,
    "value": 30000000
   },
   {
    "id": 894914,
    "value": 28000000
   },
   {
    "id": 238407,
    "value": 25000000
   },
   {
    "id": 661207,
    "value": 25000000
   },
   {
    "id": 223367,
    "value": 20000000
   },
   {
    "id": 370789,
    "value": 20000000
   },
   {
    "id": 328658,
    "value": 18000000
   },
   {
    "id": 670103,
    "value": 15000000
   },
   {
    "id": 911736,
    "value": 15000000
   },
   {
    "id": 923504,
    "value": 15000000
   },
   {
    "id": 367284,
    "value": 10000000
   },
   {
    "id": 564785,
    "value": 9000000
   },
   {
    "id": 661427,
    "value": 9000000
   },
   {
    "id": 903359,
    "value": 7000000
   },
   {
    "id": 308439,
    "value": 6000000
   },
   {
    "id": 499859,
    "value": 6000000
   },
   {
    "id": 186644,
    "value": 5000000
   },
   {
    "id": 619657,
    "value": 5000000
   },
   {
    "id": 923535,
    "value": 5000000
   },
   {
    "id": 367274,
    "value": 4000000
   },
   {
    "id": 422355,
    "value": 4000000
   }
  ],
  "CAN": [
   {
    "id": 424204,
    "value": 50000000
   },
   {
    "id": 533738,
    "value": 45000000
   },
   {
    "id": 512913,
    "value": 10000000
   },
   {
    "id": 921655,
    "value": 9000000
   },
   {
    "id": 638793,
    "value": 6000000
   },
   {
    "id": 328609,
    "value": 5000000
   },
   {
    "id": 972465,
    "value": 5000000
   },
   {
    "id": 637632,
    "value": 4000000
   },
   {
    "id": 343463,
    "value": 3500000
   },
   {
    "id": 683625,
    "value": 3500000
   },
   {
    "id": 842420,
    "value": 3500000
   },
   {
    "id": 189014,
    "value": 3000000
   },
   {
    "id": 487417,
    "value": 3000000
   },
   {
    "id": 441738,
    "value": 2500000
   },
   {
    "id": 501709,
    "value": 1800000
   },
   {
    "id": 568535,
    "value": 1800000
   },
   {
    "id": 982519,
    "value": 1800000
   },
   {
    "id": 260807,
    "value": 1500000
   },
   {
    "id": 221038,
    "value": 1000000
   },
   {
    "id": 343553,
    "value": 1000000
   },
   {
    "id": 417348,
    "value": 1000000
   },
   {
    "id": 749407,
    "value": 1000000
   },
   {
    "id": 367429,
    "value": 800000
   }
  ],
  "ALG": [
   {
    "id": 578391,
    "value": 35000000
   },
   {
    "id": 746910,
    "value": 32000000
   },
   {
    "id": 351816,
    "value": 15000000
   },
   {
    "id": 290532,
    "value": 10000000
   },
   {
    "id": 171424,
    "value": 8000000
   },
   {
    "id": 284732,
    "value": 7000000
   },
   {
    "id": 592979,
    "value": 7000000
   },
   {
    "id": 245537,
    "value": 6000000
   },
   {
    "id": 739769,
    "value": 5000000
   },
   {
    "id": 857079,
    "value": 4500000
   },
   {
    "id": 425400,
    "value": 3500000
   },
   {
    "id": 416108,
    "value": 3000000
   },
   {
    "id": 209992,
    "value": 2500000
   },
   {
    "id": 645764,
    "value": 2500000
   },
   {
    "id": 674013,
    "value": 2500000
   },
   {
    "id": 348601,
    "value": 2200000
   },
   {
    "id": 592400,
    "value": 2200000
   },
   {
    "id": 400485,
    "value": 2000000
   },
   {
    "id": 587588,
    "value": 2000000
   },
   {
    "id": 543051,
    "value": 1800000
   },
   {
    "id": 175014,
    "value": 1700000
   },
   {
    "id": 202318,
    "value": 1500000
   },
   {
    "id": 966312,
    "value": 1500000
   }
  ],
  "CIV": [
   {
    "id": 536835,
    "value": 45000000
   },
   {
    "id": 974982,
    "value": 45000000
   },
   {
    "id": 556385,
    "value": 40000000
   },
   {
    "id": 371149,
    "value": 30000000
   },
   {
    "id": 658536,
    "value": 28000000
   },
   {
    "id": 644771,
    "value": 25000000
   },
   {
    "id": 648779,
    "value": 25000000
   },
   {
    "id": 315867,
    "value": 24000000
   },
   {
    "id": 357992,
    "value": 24000000
   },
   {
    "id": 375885,
    "value": 24000000
   },
   {
    "id": 683895,
    "value": 20000000
   },
   {
    "id": 301238,
    "value": 18000000
   },
   {
    "id": 392964,
    "value": 18000000
   },
   {
    "id": 1178758,
    "value": 17000000
   },
   {
    "id": 294808,
    "value": 14000000
   },
   {
    "id": 787618,
    "value": 12000000
   },
   {
    "id": 182893,
    "value": 10000000
   },
   {
    "id": 216569,
    "value": 10000000
   },
   {
    "id": 962555,
    "value": 10000000
   },
   {
    "id": 430280,
    "value": 8500000
   },
   {
    "id": 538918,
    "value": 8500000
   },
   {
    "id": 234781,
    "value": 8000000
   },
   {
    "id": 658531,
    "value": 8000000
   }
  ],
  "MEX": [
   {
    "id": 552955,
    "value": 30000000
   },
   {
    "id": 401356,
    "value": 25000000
   },
   {
    "id": 532937,
    "value": 14000000
   },
   {
    "id": 316889,
    "value": 10000000
   },
   {
    "id": 424689,
    "value": 10000000
   },
   {
    "id": 513970,
    "value": 10000000
   },
   {
    "id": 331059,
    "value": 8000000
   },
   {
    "id": 334042,
    "value": 7000000
   },
   {
    "id": 353583,
    "value": 6500000
   },
   {
    "id": 915155,
    "value": 6500000
   },
   {
    "id": 540315,
    "value": 6000000
   },
   {
    "id": 699797,
    "value": 6000000
   },
   {
    "id": 312568,
    "value": 5500000
   },
   {
    "id": 504113,
    "value": 5500000
   },
   {
    "id": 206040,
    "value": 5000000
   },
   {
    "id": 534620,
    "value": 5000000
   },
   {
    "id": 723240,
    "value": 5000000
   },
   {
    "id": 802855,
    "value": 5000000
   },
   {
    "id": 387687,
    "value": 4500000
   },
   {
    "id": 411709,
    "value": 4500000
   },
   {
    "id": 532938,
    "value": 4500000
   },
   {
    "id": 397003,
    "value": 4000000
   },
   {
    "id": 549294,
    "value": 4000000
   }
  ],
  "COL": [
   {
    "id": 480692,
    "value": 70000000
   },
   {
    "id": 493003,
    "value": 25000000
   },
   {
    "id": 413565,
    "value": 22000000
   },
   {
    "id": 341429,
    "value": 20000000
   },
   {
    "id": 459463,
    "value": 18000000
   },
   {
    "id": 588989,
    "value": 17000000
   },
   {
    "id": 512385,
    "value": 15000000
   },
   {
    "id": 857818,
    "value": 15000000
   },
   {
    "id": 185245,
    "value": 12000000
   },
   {
    "id": 262980,
    "value": 10000000
   },
   {
    "id": 362667,
    "value": 10000000
   },
   {
    "id": 686965,
    "value": 9000000
   },
   {
    "id": 257668,
    "value": 8000000
   },
   {
    "id": 424784,
    "value": 8000000
   },
   {
    "id": 716276,
    "value": 8000000
   },
   {
    "id": 262999,
    "value": 7500000
   },
   {
    "id": 354145,
    "value": 7000000
   },
   {
    "id": 474589,
    "value": 7000000
   },
   {
    "id": 323831,
    "value": 6000000
   },
   {
    "id": 388266,
    "value": 4000000
   },
   {
    "id": 585747,
    "value": 3500000
   },
   {
    "id": 654766,
    "value": 3500000
   },
   {
    "id": 73794,
    "value": 3500000
   }
  ],
  "KOR": [
   {
    "id": 503482,
    "value": 40000000
   },
   {
    "id": 557149,
    "value": 25000000
   },
   {
    "id": 91845,
    "value": 20000000
   },
   {
    "id": 292246,
    "value": 12000000
   },
   {
    "id": 365394,
    "value": 10000000
   },
   {
    "id": 639414,
    "value": 4500000
   },
   {
    "id": 1004327,
    "value": 3500000
   },
   {
    "id": 652537,
    "value": 3500000
   },
   {
    "id": 638571,
    "value": 2000000
   },
   {
    "id": 379438,
    "value": 1600000
   },
   {
    "id": 282689,
    "value": 1500000
   },
   {
    "id": 709166,
    "value": 1500000
   },
   {
    "id": 558086,
    "value": 1400000
   },
   {
    "id": 706968,
    "value": 1400000
   },
   {
    "id": 374076,
    "value": 1200000
   },
   {
    "id": 630269,
    "value": 1000000
   },
   {
    "id": 706963,
    "value": 1000000
   },
   {
    "id": 260171,
    "value": 800000
   },
   {
    "id": 402151,
    "value": 800000
   },
   {
    "id": 426201,
    "value": 800000
   },
   {
    "id": 429696,
    "value": 800000
   },
   {
    "id": 264082,
    "value": 750000
   },
   {
    "id": 524592,
    "value": 750000
   }
  ],
  "MAR": [
   {
    "id": 314678,
    "value": 40000000
   },
   {
    "id": 654982,
    "value": 28000000
   },
   {
    "id": 810895,
    "value": 28000000
   },
   {
    "id": 340456,
    "value": 25000000
   },
   {
    "id": 433049,
    "value": 24000000
   },
   {
    "id": 361914,
    "value": 18000000
   },
   {
    "id": 532776,
    "value": 18000000
   },
   {
    "id": 689637,
    "value": 15000000
   },
   {
    "id": 822331,
    "value": 15000000
   },
   {
    "id": 901019,
    "value": 15000000
   },
   {
    "id": 393238,
    "value": 12000000
   },
   {
    "id": 724520,
    "value": 12000000
   },
   {
    "id": 820474,
    "value": 12000000
   },
   {
    "id": 1054934,
    "value": 10000000
   },
   {
    "id": 593482,
    "value": 10000000
   },
   {
    "id": 541134,
    "value": 9000000
   },
   {
    "id": 893675,
    "value": 8500000
   },
   {
    "id": 372711,
    "value": 8000000
   },
   {
    "id": 559979,
    "value": 7500000
   },
   {
    "id": 358003,
    "value": 7000000
   },
   {
    "id": 885445,
    "value": 7000000
   },
   {
    "id": 380473,
    "value": 6000000
   },
   {
    "id": 635336,
    "value": 6000000
   }
  ],
  "ECU": [
   {
    "id": 687626,
    "value": 90000000
   },
   {
    "id": 349599,
    "value": 30000000
   },
   {
    "id": 592735,
    "value": 8000000
   },
   {
    "id": 568005,
    "value": 7000000
   },
   {
    "id": 450211,
    "value": 5000000
   },
   {
    "id": 400960,
    "value": 4000000
   },
   {
    "id": 450241,
    "value": 3800000
   },
   {
    "id": 713787,
    "value": 3500000
   },
   {
    "id": 941418,
    "value": 3500000
   },
   {
    "id": 897051,
    "value": 3000000
   },
   {
    "id": 439914,
    "value": 2800000
   },
   {
    "id": 659793,
    "value": 2800000
   },
   {
    "id": 189485,
    "value": 2500000
   },
   {
    "id": 606872,
    "value": 2500000
   },
   {
    "id": 332829,
    "value": 2000000
   },
   {
    "id": 425567,
    "value": 2000000
   },
   {
    "id": 491616,
    "value": 2000000
   },
   {
    "id": 903611,
    "value": 2000000
   },
   {
    "id": 139503,
    "value": 1700000
   },
   {
    "id": 189475,
    "value": 1500000
   },
   {
    "id": 310639,
    "value": 1500000
   },
   {
    "id": 379838,
    "value": 1500000
   },
   {
    "id": 684159,
    "value": 1500000
   }
  ],
  "SUI": [
   {
    "id": 257814,
    "value": 40000000
   },
   {
    "id": 365108,
    "value": 35000000
   },
   {
    "id": 608172,
    "value": 32000000
   },
   {
    "id": 334526,
    "value": 30000000
   },
   {
    "id": 284730,
    "value": 28000000
   },
   {
    "id": 496857,
    "value": 25000000
   },
   {
    "id": 583058,
    "value": 14000000
   },
   {
    "id": 449592,
    "value": 13000000
   },
   {
    "id": 543771,
    "value": 13000000
   },
   {
    "id": 111455,
    "value": 12000000
   },
   {
    "id": 237662,
    "value": 12000000
   },
   {
    "id": 257732,
    "value": 12000000
   },
   {
    "id": 571743,
    "value": 12000000
   },
   {
    "id": 579459,
    "value": 12000000
   },
   {
    "id": 583917,
    "value": 10000000
   },
   {
    "id": 667457,
    "value": 10000000
   },
   {
    "id": 521872,
    "value": 8000000
   },
   {
    "id": 212723,
    "value": 7500000
   },
   {
    "id": 371371,
    "value": 7500000
   },
   {
    "id": 135343,
    "value": 7000000
   },
   {
    "id": 315289,
    "value": 7000000
   },
   {
    "id": 345886,
    "value": 7000000
   },
   {
    "id": 382478,
    "value": 7000000
   }
  ],
  "BEL": [
   {
    "id": 368887,
    "value": 50000000
   },
   {
    "id": 486049,
    "value": 50000000
   },
   {
    "id": 249565,
    "value": 38000000
   },
   {
    "id": 435772,
    "value": 35000000
   },
   {
    "id": 743386,
    "value": 30000000
   },
   {
    "id": 338670,
    "value": 25000000
   },
   {
    "id": 144028,
    "value": 22000000
   },
   {
    "id": 490384,
    "value": 22000000
   },
   {
    "id": 926694,
    "value": 22000000
   },
   {
    "id": 96341,
    "value": 22000000
   },
   {
    "id": 108390,
    "value": 20000000
   },
   {
    "id": 303259,
    "value": 20000000
   },
   {
    "id": 88755,
    "value": 20000000
   },
   {
    "id": 655012,
    "value": 18000000
   },
   {
    "id": 381950,
    "value": 17000000
   },
   {
    "id": 429915,
    "value": 16000000
   },
   {
    "id": 292808,
    "value": 15000000
   },
   {
    "id": 357233,
    "value": 15000000
   },
   {
    "id": 631821,
    "value": 15000000
   },
   {
    "id": 724129,
    "value": 15000000
   },
   {
    "id": 565435,
    "value": 12000000
   },
   {
    "id": 588866,
    "value": 12000000
   },
   {
    "id": 669306,
    "value": 12000000
   }
  ],
  "CRO": [
   {
    "id": 475959,
    "value": 75000000
   },
   {
    "id": 483046,
    "value": 32000000
   },
   {
    "id": 51471,
    "value": 20000000
   },
   {
    "id": 548028,
    "value": 13000000
   },
   {
    "id": 892160,
    "value": 12000000
   },
   {
    "id": 156617,
    "value": 10000000
   },
   {
    "id": 205938,
    "value": 10000000
   },
   {
    "id": 282144,
    "value": 10000000
   },
   {
    "id": 432758,
    "value": 10000000
   },
   {
    "id": 370997,
    "value": 9000000
   },
   {
    "id": 293200,
    "value": 8000000
   },
   {
    "id": 580635,
    "value": 8000000
   },
   {
    "id": 374954,
    "value": 6500000
   },
   {
    "id": 403760,
    "value": 6500000
   },
   {
    "id": 387110,
    "value": 6000000
   },
   {
    "id": 395928,
    "value": 6000000
   },
   {
    "id": 46413,
    "value": 5000000
   },
   {
    "id": 605268,
    "value": 5000000
   },
   {
    "id": 95438,
    "value": 5000000
   },
   {
    "id": 316934,
    "value": 4500000
   },
   {
    "id": 27992,
    "value": 4000000
   },
   {
    "id": 357003,
    "value": 4000000
   },
   {
    "id": 357778,
    "value": 4000000
   }
  ],
  "BIH": [
   {
    "id": 357498,
    "value": 35000000
   },
   {
    "id": 413507,
    "value": 35000000
   },
   {
    "id": 335457,
    "value": 22000000
   },
   {
    "id": 465555,
    "value": 20000000
   },
   {
    "id": 377468,
    "value": 18000000
   },
   {
    "id": 574671,
    "value": 18000000
   },
   {
    "id": 528833,
    "value": 17000000
   },
   {
    "id": 257474,
    "value": 16000000
   },
   {
    "id": 470794,
    "value": 16000000
   },
   {
    "id": 668207,
    "value": 14000000
   },
   {
    "id": 780136,
    "value": 11000000
   },
   {
    "id": 574660,
    "value": 9000000
   },
   {
    "id": 190263,
    "value": 8000000
   },
   {
    "id": 206843,
    "value": 8000000
   },
   {
    "id": 94005,
    "value": 7000000
   },
   {
    "id": 552223,
    "value": 6000000
   },
   {
    "id": 897510,
    "value": 6000000
   },
   {
    "id": 336382,
    "value": 5500000
   },
   {
    "id": 161011,
    "value": 5000000
   },
   {
    "id": 419648,
    "value": 5000000
   },
   {
    "id": 615302,
    "value": 5000000
   },
   {
    "id": 625206,
    "value": 5000000
   },
   {
    "id": 845872,
    "value": 5000000
   }
  ],
  "NZL": [
   {
    "id": 108725,
    "value": 10000000
   },
   {
    "id": 469211,
    "value": 3000000
   },
   {
    "id": 617018,
    "value": 3000000
   },
   {
    "id": 1007720,
    "value": 1200000
   },
   {
    "id": 724809,
    "value": 800000
   },
   {
    "id": 203357,
    "value": 700000
   },
   {
    "id": 617021,
    "value": 700000
   },
   {
    "id": 207061,
    "value": 600000
   },
   {
    "id": 256019,
    "value": 600000
   },
   {
    "id": 539502,
    "value": 550000
   },
   {
    "id": 149901,
    "value": 450000
   },
   {
    "id": 312317,
    "value": 450000
   },
   {
    "id": 172333,
    "value": 400000
   },
   {
    "id": 485449,
    "value": 400000
   },
   {
    "id": 617019,
    "value": 400000
   },
   {
    "id": 1109358,
    "value": 350000
   },
   {
    "id": 290838,
    "value": 350000
   },
   {
    "id": 50200,
    "value": 350000
   },
   {
    "id": 350357,
    "value": 300000
   },
   {
    "id": 408965,
    "value": 300000
   },
   {
    "id": 482204,
    "value": 300000
   },
   {
    "id": 835410,
    "value": 300000
   },
   {
    "id": 345343,
    "value": 250000
   }
  ],
  "SWE": [
   {
    "id": 349066,
    "value": 120000000
   },
   {
    "id": 325443,
    "value": 75000000
   },
   {
    "id": 431755,
    "value": 50000000
   },
   {
    "id": 583189,
    "value": 42000000
   },
   {
    "id": 866246,
    "value": 38000000
   },
   {
    "id": 1012534,
    "value": 30000000
   },
   {
    "id": 503075,
    "value": 30000000
   },
   {
    "id": 400489,
    "value": 14000000
   },
   {
    "id": 342405,
    "value": 12000000
   },
   {
    "id": 468066,
    "value": 12000000
   },
   {
    "id": 579287,
    "value": 12000000
   },
   {
    "id": 184573,
    "value": 8000000
   },
   {
    "id": 496745,
    "value": 8000000
   },
   {
    "id": 663237,
    "value": 8000000
   },
   {
    "id": 792331,
    "value": 7500000
   },
   {
    "id": 362108,
    "value": 7000000
   },
   {
    "id": 486624,
    "value": 6500000
   },
   {
    "id": 258987,
    "value": 6000000
   },
   {
    "id": 422929,
    "value": 6000000
   },
   {
    "id": 475949,
    "value": 6000000
   },
   {
    "id": 527896,
    "value": 6000000
   },
   {
    "id": 667251,
    "value": 6000000
   },
   {
    "id": 322989,
    "value": 5500000
   }
  ],
  "TUN": [
   {
    "id": 607224,
    "value": 12000000
   },
   {
    "id": 290587,
    "value": 7500000
   },
   {
    "id": 496706,
    "value": 6000000
   },
   {
    "id": 233782,
    "value": 4000000
   },
   {
    "id": 673513,
    "value": 4000000
   },
   {
    "id": 645589,
    "value": 3500000
   },
   {
    "id": 546712,
    "value": 3000000
   },
   {
    "id": 388220,
    "value": 1800000
   },
   {
    "id": 406008,
    "value": 1400000
   },
   {
    "id": 103565,
    "value": 1000000
   },
   {
    "id": 450417,
    "value": 1000000
   },
   {
    "id": 275956,
    "value": 900000
   },
   {
    "id": 270411,
    "value": 750000
   },
   {
    "id": 208880,
    "value": 700000
   },
   {
    "id": 346776,
    "value": 600000
   },
   {
    "id": 401836,
    "value": 600000
   },
   {
    "id": 633399,
    "value": 600000
   },
   {
    "id": 69110,
    "value": 600000
   },
   {
    "id": 578292,
    "value": 500000
   },
   {
    "id": 192167,
    "value": 400000
   },
   {
    "id": 125023,
    "value": 300000
   },
   {
    "id": 756591,
    "value": 300000
   },
   {
    "id": 11492,
    "value": 250000
   }
  ],
  "CZE": [
   {
    "id": 283628,
    "value": 18000000
   },
   {
    "id": 725912,
    "value": 15000000
   },
   {
    "id": 652054,
    "value": 11000000
   },
   {
    "id": 500053,
    "value": 10000000
   },
   {
    "id": 242063,
    "value": 8000000
   },
   {
    "id": 321204,
    "value": 8000000
   },
   {
    "id": 337333,
    "value": 6000000
   },
   {
    "id": 629773,
    "value": 6000000
   },
   {
    "id": 157672,
    "value": 5000000
   },
   {
    "id": 500054,
    "value": 5000000
   },
   {
    "id": 611049,
    "value": 4500000
   },
   {
    "id": 334802,
    "value": 4000000
   },
   {
    "id": 396235,
    "value": 4000000
   },
   {
    "id": 486604,
    "value": 4000000
   },
   {
    "id": 198614,
    "value": 3500000
   },
   {
    "id": 620217,
    "value": 3500000
   },
   {
    "id": 242089,
    "value": 3000000
   },
   {
    "id": 293357,
    "value": 3000000
   },
   {
    "id": 544148,
    "value": 3000000
   },
   {
    "id": 563033,
    "value": 3000000
   },
   {
    "id": 666268,
    "value": 3000000
   },
   {
    "id": 272261,
    "value": 2500000
   },
   {
    "id": 242084,
    "value": 2000000
   }
  ],
  "HTI": [
   {
    "id": 492955,
    "value": 3200000
   },
   {
    "id": 344864,
    "value": 2500000
   },
   {
    "id": 628834,
    "value": 2000000
   },
   {
    "id": 371686,
    "value": 1800000
   },
   {
    "id": 345763,
    "value": 1200000
   },
   {
    "id": 354763,
    "value": 1000000
   },
   {
    "id": 899418,
    "value": 600000
   },
   {
    "id": 458345,
    "value": 350000
   },
   {
    "id": 552467,
    "value": 300000
   },
   {
    "id": 51035,
    "value": 200000
   },
   {
    "id": 609691,
    "value": 200000
   },
   {
    "id": 354752,
    "value": 150000
   },
   {
    "id": 715819,
    "value": 150000
   },
   {
    "id": 294687,
    "value": 125000
   },
   {
    "id": 309512,
    "value": 125000
   },
   {
    "id": 478810,
    "value": 100000
   },
   {
    "id": 992225,
    "value": 100000
   },
   {
    "id": 624869,
    "value": 75000
   },
   {
    "id": 737772,
    "value": 75000
   },
   {
    "id": 838947,
    "value": 25000
   },
   {
    "id": 1015452,
    "value": 0
   },
   {
    "id": 1020515,
    "value": 0
   },
   {
    "id": 103633,
    "value": 0
   }
  ],
  "URU": [
   {
    "id": 369081,
    "value": 130000000
   },
   {
    "id": 476701,
    "value": 45000000
   },
   {
    "id": 546543,
    "value": 45000000
   },
   {
    "id": 480267,
    "value": 35000000
   },
   {
    "id": 354362,
    "value": 30000000
   },
   {
    "id": 250845,
    "value": 20000000
   },
   {
    "id": 376514,
    "value": 20000000
   },
   {
    "id": 572675,
    "value": 17000000
   },
   {
    "id": 248410,
    "value": 15000000
   },
   {
    "id": 465822,
    "value": 15000000
   },
   {
    "id": 318077,
    "value": 13000000
   },
   {
    "id": 290249,
    "value": 12000000
   },
   {
    "id": 438001,
    "value": 10000000
   },
   {
    "id": 707447,
    "value": 9000000
   },
   {
    "id": 317454,
    "value": 8500000
   },
   {
    "id": 676318,
    "value": 8000000
   },
   {
    "id": 446106,
    "value": 6500000
   },
   {
    "id": 481367,
    "value": 6500000
   },
   {
    "id": 465818,
    "value": 6000000
   },
   {
    "id": 611426,
    "value": 6000000
   },
   {
    "id": 657746,
    "value": 6000000
   },
   {
    "id": 310744,
    "value": 5500000
   },
   {
    "id": 439072,
    "value": 5000000
   }
  ],
  "GHA": [
   {
    "id": 543499,
    "value": 45000000
   },
   {
    "id": 583255,
    "value": 40000000
   },
   {
    "id": 565821,
    "value": 30000000
   },
   {
    "id": 406634,
    "value": 22000000
   },
   {
    "id": 585323,
    "value": 18000000
   },
   {
    "id": 255508,
    "value": 15000000
   },
   {
    "id": 400536,
    "value": 15000000
   },
   {
    "id": 569663,
    "value": 15000000
   },
   {
    "id": 955070,
    "value": 15000000
   },
   {
    "id": 230784,
    "value": 14000000
   },
   {
    "id": 289835,
    "value": 14000000
   },
   {
    "id": 746695,
    "value": 13000000
   },
   {
    "id": 342389,
    "value": 12000000
   },
   {
    "id": 563963,
    "value": 12000000
   },
   {
    "id": 503866,
    "value": 11000000
   },
   {
    "id": 864121,
    "value": 11000000
   },
   {
    "id": 1110406,
    "value": 10000000
   },
   {
    "id": 422951,
    "value": 10000000
   },
   {
    "id": 462832,
    "value": 10000000
   },
   {
    "id": 798404,
    "value": 9000000
   },
   {
    "id": 610400,
    "value": 8000000
   },
   {
    "id": 734676,
    "value": 8000000
   },
   {
    "id": 514888,
    "value": 7000000
   }
  ],
  "QAT": [
   {
    "id": 336646,
    "value": 8000000
   },
   {
    "id": 237846,
    "value": 2500000
   },
   {
    "id": 115382,
    "value": 1000000
   },
   {
    "id": 560423,
    "value": 850000
   },
   {
    "id": 311730,
    "value": 600000
   },
   {
    "id": 481935,
    "value": 550000
   },
   {
    "id": 86286,
    "value": 450000
   },
   {
    "id": 736005,
    "value": 400000
   },
   {
    "id": 83983,
    "value": 400000
   },
   {
    "id": 415049,
    "value": 350000
   },
   {
    "id": 561030,
    "value": 350000
   },
   {
    "id": 589099,
    "value": 300000
   },
   {
    "id": 834862,
    "value": 300000
   },
   {
    "id": 222669,
    "value": 250000
   },
   {
    "id": 560970,
    "value": 225000
   },
   {
    "id": 228727,
    "value": 200000
   },
   {
    "id": 589100,
    "value": 200000
   },
   {
    "id": 308650,
    "value": 175000
   },
   {
    "id": 375744,
    "value": 175000
   },
   {
    "id": 150884,
    "value": 150000
   },
   {
    "id": 254900,
    "value": 125000
   },
   {
    "id": 753386,
    "value": 125000
   },
   {
    "id": 143539,
    "value": 100000
   }
  ],
  "CUW": [
   {
    "id": 348863,
    "value": 3000000
   },
   {
    "id": 315211,
    "value": 850000
   },
   {
    "id": 374889,
    "value": 750000
   },
   {
    "id": 401029,
    "value": 450000
   },
   {
    "id": 538958,
    "value": 400000
   },
   {
    "id": 708005,
    "value": 400000
   },
   {
    "id": 126014,
    "value": 300000
   },
   {
    "id": 232219,
    "value": 300000
   },
   {
    "id": 326997,
    "value": 300000
   },
   {
    "id": 226100,
    "value": 250000
   },
   {
    "id": 442658,
    "value": 250000
   },
   {
    "id": 111183,
    "value": 200000
   },
   {
    "id": 275939,
    "value": 200000
   },
   {
    "id": 79294,
    "value": 200000
   },
   {
    "id": 240752,
    "value": 175000
   },
   {
    "id": 124885,
    "value": 150000
   },
   {
    "id": 451576,
    "value": 150000
   },
   {
    "id": 66783,
    "value": 125000
   },
   {
    "id": 806284,
    "value": 100000
   },
   {
    "id": 91251,
    "value": 100000
   },
   {
    "id": 229228,
    "value": 75000
   },
   {
    "id": 1019546,
    "value": 0
   },
   {
    "id": 139198,
    "value": 0
   }
  ],
  "JPN": [
   {
    "id": 504849,
    "value": 40000000
   },
   {
    "id": 405398,
    "value": 30000000
   },
   {
    "id": 353892,
    "value": 25000000
   },
   {
    "id": 358504,
    "value": 25000000
   },
   {
    "id": 432298,
    "value": 20000000
   },
   {
    "id": 643574,
    "value": 20000000
   },
   {
    "id": 331560,
    "value": 18000000
   },
   {
    "id": 165793,
    "value": 15000000
   },
   {
    "id": 524315,
    "value": 13000000
   },
   {
    "id": 355816,
    "value": 12000000
   },
   {
    "id": 356141,
    "value": 12000000
   },
   {
    "id": 415035,
    "value": 11000000
   },
   {
    "id": 489359,
    "value": 10000000
   },
   {
    "id": 489463,
    "value": 9000000
   },
   {
    "id": 146310,
    "value": 8000000
   },
   {
    "id": 405397,
    "value": 8000000
   },
   {
    "id": 348791,
    "value": 6000000
   },
   {
    "id": 617408,
    "value": 4500000
   },
   {
    "id": 415525,
    "value": 4000000
   },
   {
    "id": 501743,
    "value": 4000000
   },
   {
    "id": 733438,
    "value": 4000000
   },
   {
    "id": 262489,
    "value": 3500000
   },
   {
    "id": 353886,
    "value": 3500000
   }
  ],
  "SEN": [
   {
    "id": 776890,
    "value": 50000000
   },
   {
    "id": 568693,
    "value": 32000000
   },
   {
    "id": 410225,
    "value": 25000000
   },
   {
    "id": 1111589,
    "value": 18000000
   },
   {
    "id": 626913,
    "value": 15000000
   },
   {
    "id": 776798,
    "value": 9000000
   },
   {
    "id": 200512,
    "value": 8000000
   },
   {
    "id": 768380,
    "value": 8000000
   },
   {
    "id": 1099668,
    "value": 7500000
   },
   {
    "id": 375137,
    "value": 7000000
   },
   {
    "id": 490426,
    "value": 7000000
   },
   {
    "id": 442531,
    "value": 5000000
   },
   {
    "id": 480705,
    "value": 5000000
   },
   {
    "id": 1178488,
    "value": 4000000
   },
   {
    "id": 568696,
    "value": 4000000
   },
   {
    "id": 649026,
    "value": 4000000
   },
   {
    "id": 673514,
    "value": 4000000
   },
   {
    "id": 379168,
    "value": 3000000
   },
   {
    "id": 649022,
    "value": 3000000
   },
   {
    "id": 822458,
    "value": 3000000
   },
   {
    "id": 644032,
    "value": 2500000
   },
   {
    "id": 649023,
    "value": 2500000
   },
   {
    "id": 891998,
    "value": 2500000
   }
  ],
  "CPV": [
   {
    "id": 1072017,
    "value": 5000000
   },
   {
    "id": 544586,
    "value": 5000000
   },
   {
    "id": 791528,
    "value": 3000000
   },
   {
    "id": 697716,
    "value": 2500000
   },
   {
    "id": 197170,
    "value": 2000000
   },
   {
    "id": 203517,
    "value": 1800000
   },
   {
    "id": 272930,
    "value": 1000000
   },
   {
    "id": 448466,
    "value": 1000000
   },
   {
    "id": 1160599,
    "value": 800000
   },
   {
    "id": 383654,
    "value": 800000
   },
   {
    "id": 549016,
    "value": 800000
   },
   {
    "id": 820252,
    "value": 700000
   },
   {
    "id": 247666,
    "value": 600000
   },
   {
    "id": 306166,
    "value": 600000
   },
   {
    "id": 341516,
    "value": 600000
   },
   {
    "id": 647132,
    "value": 600000
   },
   {
    "id": 657635,
    "value": 600000
   },
   {
    "id": 170895,
    "value": 500000
   },
   {
    "id": 632857,
    "value": 500000
   },
   {
    "id": 1173606,
    "value": 400000
   },
   {
    "id": 153427,
    "value": 400000
   },
   {
    "id": 581000,
    "value": 400000
   },
   {
    "id": 476527,
    "value": 350000
   }
  ],
  "COD": [
   {
    "id": 388165,
    "value": 32000000
   },
   {
    "id": 344869,
    "value": 14000000
   },
   {
    "id": 280701,
    "value": 6000000
   },
   {
    "id": 395522,
    "value": 4500000
   },
   {
    "id": 410649,
    "value": 4000000
   },
   {
    "id": 423678,
    "value": 4000000
   },
   {
    "id": 486477,
    "value": 4000000
   },
   {
    "id": 342048,
    "value": 3500000
   },
   {
    "id": 181380,
    "value": 3000000
   },
   {
    "id": 679709,
    "value": 3000000
   },
   {
    "id": 243879,
    "value": 2400000
   },
   {
    "id": 395685,
    "value": 2000000
   },
   {
    "id": 922788,
    "value": 2000000
   },
   {
    "id": 353403,
    "value": 1600000
   },
   {
    "id": 127048,
    "value": 1500000
   },
   {
    "id": 170463,
    "value": 1500000
   },
   {
    "id": 503795,
    "value": 1500000
   },
   {
    "id": 541420,
    "value": 1400000
   },
   {
    "id": 289432,
    "value": 1200000
   },
   {
    "id": 368612,
    "value": 1200000
   },
   {
    "id": 381968,
    "value": 1200000
   },
   {
    "id": 244338,
    "value": 1000000
   },
   {
    "id": 595652,
    "value": 800000
   }
  ],
  "IRN": [
   {
    "id": 180337,
    "value": 8000000
   },
   {
    "id": 307058,
    "value": 3500000
   },
   {
    "id": 603149,
    "value": 3000000
   },
   {
    "id": 204294,
    "value": 1500000
   },
   {
    "id": 213268,
    "value": 1500000
   },
   {
    "id": 249271,
    "value": 1300000
   },
   {
    "id": 249360,
    "value": 1200000
   },
   {
    "id": 333355,
    "value": 1200000
   },
   {
    "id": 617937,
    "value": 1000000
   },
   {
    "id": 229081,
    "value": 800000
   },
   {
    "id": 350828,
    "value": 700000
   },
   {
    "id": 343044,
    "value": 650000
   },
   {
    "id": 294778,
    "value": 600000
   },
   {
    "id": 218431,
    "value": 400000
   },
   {
    "id": 132553,
    "value": 350000
   },
   {
    "id": 479233,
    "value": 50000
   },
   {
    "id": 103006,
    "value": 0
   },
   {
    "id": 1051589,
    "value": 0
   },
   {
    "id": 113244,
    "value": 0
   },
   {
    "id": 132573,
    "value": 0
   },
   {
    "id": 133838,
    "value": 0
   },
   {
    "id": 145114,
    "value": 0
   },
   {
    "id": 16094,
    "value": 0
   }
  ],
  "RSA": [
   {
    "id": 467623,
    "value": 6000000
   },
   {
    "id": 512980,
    "value": 2000000
   },
   {
    "id": 390478,
    "value": 1200000
   },
   {
    "id": 427161,
    "value": 1000000
   },
   {
    "id": 445616,
    "value": 1000000
   },
   {
    "id": 494384,
    "value": 1000000
   },
   {
    "id": 346095,
    "value": 850000
   },
   {
    "id": 467616,
    "value": 800000
   },
   {
    "id": 387378,
    "value": 600000
   },
   {
    "id": 1069801,
    "value": 400000
   },
   {
    "id": 467610,
    "value": 350000
   },
   {
    "id": 388581,
    "value": 250000
   },
   {
    "id": 898140,
    "value": 250000
   },
   {
    "id": 308117,
    "value": 200000
   },
   {
    "id": 401736,
    "value": 200000
   },
   {
    "id": 703577,
    "value": 200000
   },
   {
    "id": 108601,
    "value": 75000
   },
   {
    "id": 1030524,
    "value": 25000
   },
   {
    "id": 103459,
    "value": 0
   },
   {
    "id": 103469,
    "value": 0
   },
   {
    "id": 109899,
    "value": 0
   },
   {
    "id": 110082,
    "value": 0
   },
   {
    "id": 123639,
    "value": 0
   }
  ],
  "UZB": [
   {
    "id": 763079,
    "value": 35000000
   },
   {
    "id": 358166,
    "value": 5000000
   },
   {
    "id": 274536,
    "value": 1500000
   },
   {
    "id": 431912,
    "value": 850000
   },
   {
    "id": 104703,
    "value": 0
   },
   {
    "id": 106632,
    "value": 0
   },
   {
    "id": 127744,
    "value": 0
   },
   {
    "id": 143820,
    "value": 0
   },
   {
    "id": 15578,
    "value": 0
   },
   {
    "id": 15748,
    "value": 0
   },
   {
    "id": 161721,
    "value": 0
   },
   {
    "id": 172798,
    "value": 0
   },
   {
    "id": 189637,
    "value": 0
   },
   {
    "id": 208188,
    "value": 0
   },
   {
    "id": 24983,
    "value": 0
   },
   {
    "id": 25823,
    "value": 0
   },
   {
    "id": 27016,
    "value": 0
   },
   {
    "id": 288883,
    "value": 0
   },
   {
    "id": 294502,
    "value": 0
   },
   {
    "id": 34345,
    "value": 0
   },
   {
    "id": 367684,
    "value": 0
   },
   {
    "id": 49562,
    "value": 0
   },
   {
    "id": 581427,
    "value": 0
   }
  ],
  "IRQ": [
   {
    "id": 610581,
    "value": 2500000
   },
   {
    "id": 663153,
    "value": 2200000
   },
   {
    "id": 589646,
    "value": 1200000
   },
   {
    "id": 866082,
    "value": 800000
   },
   {
    "id": 303766,
    "value": 600000
   },
   {
    "id": 684307,
    "value": 600000
   },
   {
    "id": 877672,
    "value": 550000
   },
   {
    "id": 166460,
    "value": 350000
   },
   {
    "id": 1112869,
    "value": 250000
   },
   {
    "id": 559942,
    "value": 250000
   },
   {
    "id": 732828,
    "value": 250000
   },
   {
    "id": 651375,
    "value": 225000
   },
   {
    "id": 261611,
    "value": 175000
   },
   {
    "id": 95429,
    "value": 150000
   },
   {
    "id": 217073,
    "value": 100000
   },
   {
    "id": 114859,
    "value": 0
   },
   {
    "id": 155769,
    "value": 0
   },
   {
    "id": 175387,
    "value": 0
   },
   {
    "id": 196531,
    "value": 0
   },
   {
    "id": 34214,
    "value": 0
   },
   {
    "id": 37816,
    "value": 0
   },
   {
    "id": 530527,
    "value": 0
   },
   {
    "id": 61830,
    "value": 0
   }
  ],
  "EGY": [
   {
    "id": 445939,
    "value": 75000000
   },
   {
    "id": 148455,
    "value": 50000000
   },
   {
    "id": 234189,
    "value": 5000000
   },
   {
    "id": 462348,
    "value": 5000000
   },
   {
    "id": 160438,
    "value": 1800000
   },
   {
    "id": 312017,
    "value": 1500000
   },
   {
    "id": 111524,
    "value": 1200000
   },
   {
    "id": 184816,
    "value": 800000
   },
   {
    "id": 237641,
    "value": 600000
   },
   {
    "id": 123551,
    "value": 500000
   },
   {
    "id": 333004,
    "value": 300000
   },
   {
    "id": 808907,
    "value": 200000
   },
   {
    "id": 149532,
    "value": 150000
   },
   {
    "id": 1168851,
    "value": 100000
   },
   {
    "id": 1233980,
    "value": 100000
   },
   {
    "id": 158997,
    "value": 75000
   },
   {
    "id": 82377,
    "value": 25000
   },
   {
    "id": 114275,
    "value": 0
   },
   {
    "id": 1203724,
    "value": 0
   },
   {
    "id": 127706,
    "value": 0
   },
   {
    "id": 13456,
    "value": 0
   },
   {
    "id": 136937,
    "value": 0
   },
   {
    "id": 17,
    "value": 0
   }
  ],
  "PAN": [
   {
    "id": 375300,
    "value": 3800000
   },
   {
    "id": 440383,
    "value": 2500000
   },
   {
    "id": 502842,
    "value": 2500000
   },
   {
    "id": 425028,
    "value": 2000000
   },
   {
    "id": 283473,
    "value": 800000
   },
   {
    "id": 628806,
    "value": 600000
   },
   {
    "id": 345716,
    "value": 350000
   },
   {
    "id": 502844,
    "value": 325000
   },
   {
    "id": 937710,
    "value": 300000
   },
   {
    "id": 333092,
    "value": 200000
   },
   {
    "id": 496062,
    "value": 200000
   },
   {
    "id": 654162,
    "value": 200000
   },
   {
    "id": 161671,
    "value": 150000
   },
   {
    "id": 126019,
    "value": 100000
   },
   {
    "id": 121791,
    "value": 50000
   },
   {
    "id": 189525,
    "value": 50000
   },
   {
    "id": 922408,
    "value": 50000
   },
   {
    "id": 116350,
    "value": 0
   },
   {
    "id": 122016,
    "value": 0
   },
   {
    "id": 189539,
    "value": 0
   },
   {
    "id": 189533,
    "value": 0
   },
   {
    "id": 202880,
    "value": 0
   },
   {
    "id": 243298,
    "value": 0
   }
  ],
  "JOR": [
   {
    "id": 551505,
    "value": 6000000
   },
   {
    "id": 261842,
    "value": 350000
   },
   {
    "id": 157536,
    "value": 0
   },
   {
    "id": 172909,
    "value": 0
   },
   {
    "id": 220475,
    "value": 0
   },
   {
    "id": 69290,
    "value": 0
   }
  ],
  "KSA": [
   {
    "id": 193151,
    "value": 200000
   },
   {
    "id": 250826,
    "value": 150000
   },
   {
    "id": 177477,
    "value": 75000
   }
  ]
 }
}
